<template>
    <div class="animated fadeIn">
        <b-card>
            <template v-slot:header>
                <h5>Request Surat BPKB Baru</h5>
            </template>
            <b-form @submit.prevent="openModalConfirm">
                <div class="form-content-wrapper">
                    <b-form-group label="Jenis Surat">
                        <b-form-select v-model="input.jenisSurat" name="jenisSurat" :options="jenisSuratOption" value-field="id" text-field="name" required> 
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                    <b-form-group label="Alamat Tujuan">
                        <b-form-select v-model="input.tipeAlamat" :options="optTipeAlamat" value-field="id" text-field="name" required> 
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                    <div class="input-small-wrapper">
                        <b-form-group label="Persiapkan semua gadai BPKB yang melebihi ">
                            <div class="d-flex align-items-center mb-2">
                                <b-form-input class="mr-2" v-model="input.hariJatuhTempoSkemaBelakang" name="hariJatuhTempoBelakang" type="number" min="1" required></b-form-input>
                                <span class="smallText text-muted">Hari dari jatuh tempo - Untuk Barang Skema 1 (Jasa Dibelakang)</span>
                            </div>
                            <div class="d-flex align-items-center mb-2">
                                <b-form-input class="mr-2" v-model="input.hariJatuhTempoSkemaDepan" name="hariJatuhTempoBelakang" type="number" min="1" required></b-form-input>
                                <span class="smallText text-muted">Hari dari jatuh tempo - Untuk Barang Skema 2 (Jasa Didepan)</span>
                            </div>
                        </b-form-group>
                        <p class="smallText text-muted mb-0">Bila request dilakukan pada tanggal 15 Januari dan input adalah 15 hari, maka gadai BPKB yang akan dibuatkan surat adalah yang berjatuh tempo pada tanggal 1 Januari (16 Januari dikurang 15 hari)</p>
                    </div>
                </div>
                <div class="detail-data-wrapper">
                    <h6 class="form-title">CABANG</h6>
                    <b-form-group>
                        <b-form-checkbox
                            v-model="checkAllCabang" name="checkAllCabang"
                            :disabled="disabled"
                            @change="toggleAll"
                            >
                            {{ checkAllCabang ? 'Uncheck All' : 'Check All' }}
                        </b-form-checkbox>
                    </b-form-group>
                    <div>
                        <div class="search-wrapper d-flex align-items-center justify-content-between">
                            <b-form-group
                                label="Filter"
                                label-for="filterInput"
                                class="form-inline mb-3"
                            >
                                <b-form-input class="mr-2 ml-2"
                                    v-model="filter" name="filterTable"
                                    type="search"
                                    placeholder="Type to search"
                                >
                                </b-form-input>
                            </b-form-group>
                        </div>
                        <b-table bordered hover show-empty
                            :busy="isBusy"
                            :items="cabangItems" 
                            :fields="fields"
                            :currentPage="currentPage" 
                            :perPage="perPage"
                            :filter="filter"
							:filterIncludedFields="filterOn"
                            @filtered="onFiltered"
                            responsive class="mb-3">
                            <template v-slot:cell(checkCabang)="row">
                                <b-form-checkbox :id="'cb' + row.item.id" v-model="row.item.selected">
                                    {{ row.item.name }}
                                </b-form-checkbox>
                            </template>
                            <template v-slot:empty>
                                Tidak ada data cabang.
                            </template>
                        </b-table>
                        <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                            <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                                <b-form-select v-model="input.show" class="customCabangOption" id="showItems" :options="options" @change="onLimitChange">
                                    <template v-slot:first>
                                        <b-form-select-option :value="null" disabled />
                                    </template>
                                </b-form-select>
                            </b-input-group>
                            <b-pagination class="mb-0"
                                v-model="currentPage"
                                :total-rows="rows"
                                :per-page="perPage"
                                aria-controls="my-table"
                                @input="onPageChange"
                            ></b-pagination>
                        </div>
                    </div>
                </div>
                <div class="form-wrapper-btn">
                    <b-button type="submit" name="batchLelangSubmitBtn" variant="pgiBtn">Kirim</b-button>
                </div>
            </b-form>
        </b-card>
        <ModalConfirm id="modal-confirm-input" title="Confirm Request Surat BPKB Baru" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk menginput Surat BPKB ini?" @submit="onSubmit" />
    </div>
</template>

<script>

export default {
    name: 'input-surat-bpkb',
    data(){
        return{
            isSubmitting: false,
            isBusy: true,
            input: {
                hariJatuhTempoSkemaBelakang: 30,
                hariJatuhTempoSkemaDepan: 30,
                jenisSurat: 1,
                tipeAlamat: 1,
                show: 10
            },
            fields: [
                { key: "checkCabang", label: "Cabang", tdClass: "checkboxCabang" },
            ],
            rincian: {
                cabangTanpaLelang: []
            },
            options: [
                { value: 10, text: '10'},
                { value: 50, text: '50'},
                { value: 100, text: '100'},
                { value: 'All', text: 'Semua'},
            ],
            jenisSuratOption: [
                { id: 1, name: 'Peringatan'},
                { id: 2, name: 'Penarikan'},
            ],
			filter: null,
			filterOn: ["name"],
            checkAllCabang: false,
            disabled: false,
            currentPage: 1,
            perPage: 10,
            rows: null,
            cabangItems: [],

            optTipeAlamat: [
                { id: 1, name: "Alamat Sekarang" },
                { id: 2, name: "Alamat STNK" }
            ]
        }
    },
    watch: {
        "input.jenisSurat": function(newValue) {
            if(newValue == 1){
                this.input.hariJatuhTempoSkemaBelakang = 30
                this.input.hariJatuhTempoSkemaDepan = 30
            }else{
                this.input.hariJatuhTempoSkemaBelakang = 60
                this.input.hariJatuhTempoSkemaDepan = 60
            }
        },
    },
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0

            let getCabang = this.$axios.get("cabang/all-selection").then(response => {
                this.cabangItems = response.data.map(item => { return { id: item.id, name: item.name, selected: false } })
                this.updateTotalItem()
            })

            Promise.all([getCabang]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },

        //----------------- Fungsi Pagination, Sorting, dan Filtering -----------------

        onPageChange(){
            let limit = null
            limit = (this.currentPage-1) * this.input.show + this.input.show
            if(limit > this.rows) limit = this.rows
        },

        onLimitChange(){
            if(this.input.show == 'All'){
                this.perPage = this.rows
            }else{
                this.perPage = this.input.show
                this.onPageChange()
            }
            
        },
        
        onFiltered(filteredItems) {
            this.rows = filteredItems.length
            this.currentPage = 1
        },
        
        //----------------- Fungsi Submit Data -----------------

        onSubmit(){
            let payload = new FormData()
            let selectedCabang = this.cabangItems.filter(item => item.selected)
            let cabang = []

            //----------------- Append Data Surat Bpbk -----------------

            payload.append("hariMelebihiJatuhTempoSkema1", this.input.hariJatuhTempoSkemaBelakang)
            payload.append("hariMelebihiJatuhTempoSkema2", this.input.hariJatuhTempoSkemaDepan)
            payload.append("tipeAlamat", this.input.tipeAlamat)
            payload.append("jenis", this.input.jenisSurat)

            let y = 0
            for (var x of selectedCabang) {
                cabang[y] = x.id
                y++
            }

            payload.append("cabangIds", cabang)

            //----------------- Submit Semua Data -----------------

            this.isSubmitting = true

            this.$axios.post("surat-bpkb/request/", payload).then(() => {
           
                this.$helper.setFlash(`Request Surat BPKB baru telah berhasil dibuat!`)
                let path = this.$route.path.split("/")
                path.pop()
                path = path.join("/")
                this.$router.push({ path })
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        toggleAll(checked) {
            for(let i=0; i< this.cabangItems.length; i++){
                this.cabangItems[i].selected = checked
            }
        },

        updateTotalItem(){
            this.rows = this.cabangItems.length
            if (this.perPage > this.rows) this.perPage = this.rows
        },

        openModalConfirm(){
            let selectedCabang = this.cabangItems.filter(item => item.selected)
            
            if (selectedCabang.length == 0) {
     
                this.$helper.toastErr(this, "Mohon memilih minimal 1 cabang!")
            }
            else {
                this.$bvModal.show("modal-confirm-input")
   
            }
        },

    },
    created() {
        this.init()
    }
}
</script>
